import { TWarehouse } from "@helpers/validation-schemas/warehouse-and-inventory/warehouse.schema";
import DeleteButton from "@components/buttons/DeleteButton";
import EditButton from "@components/buttons/EditButton";
import InfoButton from "@components/buttons/InfoButton";
import AuthComponent from "@components/auth/component";

export const allocationAccountColumns = (
  editHandler: (warehouse: TWarehouse) => void,
  deleteHandler: (id: string | number) => Promise<void>,
  toggleModalHandler: (warehouse: TWarehouse) => void
) => [
  {
    name: "Allocation Account Name",
    selector: (row: TWarehouse) => row.warehouse_name,
    sort: true,
  },
  {
    name: "Main Warehouse",
    selector: (row: TWarehouse) =>
      row.main_warehouse_name,
    sort: true,
  },
  {
    name: "Phone Number",
    selector: (row: TWarehouse) => row.warehouse_phone1,
    sort: true,
  },
 
  {
    name: "Action",
    right: "true",
    selector: (row: TWarehouse) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <AuthComponent
          action="view"
          module="Stock & Inventory"
          subModule="Allocation Account"
        >
          <InfoButton
            id={row.warehouse_id}
            actionHandler={() => toggleModalHandler(row)}
          />
        </AuthComponent>

        <AuthComponent
          action="edit"
          module="Stock & Inventory"
          subModule="Allocation Account"
        >
          <EditButton
            id={row.warehouse_id}
            actionHandler={() => editHandler(row)}
          />
        </AuthComponent>

        <AuthComponent
          action="delete"
          module="Stock & Inventory"
          subModule="Allocation Account"
        >
          <DeleteButton id={row.warehouse_id} actionHandler={deleteHandler} />
        </AuthComponent>
      </div>
    ),
  },
];
